'use client';

import { useCallback, useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback((callback: () => void) => {
    const media = window.matchMedia(query);
    media.addEventListener('change', callback);
    return () => media.removeEventListener('change', callback);
  }, [query]);
  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);
  const getServerSnapshot = useCallback(() => false, []);
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function useIsMobile() {
  return useMediaQuery('(max-width: 768px)');
}

export function useIsTablet() {
  return useMediaQuery('(max-width: 1024px)');
}

/**
 * Detects narrow desktop viewport (1024px - 1280px).
 * Used to auto-collapse the sidebar to icon-only mode at this range.
 * Event-driven via matchMedia — no polling or intervals.
 */
export function useIsNarrowDesktop() {
  return useMediaQuery('(min-width: 1024px) and (max-width: 1279px)');
}
